
import Vue from 'vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import { LinkData } from '@root/modules/navigation/types/navigation';

interface Props {
  link: LinkData;
  fakeLink: boolean;
  placement: string;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    LinkHandler,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    fakeLink: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: '',
      required: false,
    },
  },
});
